import HTTP from "@/http-common";

export const state = {
  showGroupDialog: false,
};

export const mutations = {
  changeStatus() {
    state.showGroupDialog = !state.showGroupDialog;
  },
};

export const getters = {
  showGroupDialog: (state) => {
    return state.showGroupDialog;
  },
};

export const actions = {
  addExcludedGroup({ commit }) {
    return new Promise((resolve, reject) => {
      commit("changeStatus");
    });
  },
  async upsertGroup({ commit }, data) {
    try {
      let result = await HTTP.post(`reminder/UpsertGroup`, data);
      return Promise.resolve(result.data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
};
